<div class="modalContainer" [formGroup]="withdrawalRequestForm">
    <div class="modal-header">
        <h4 class="modal-title">Withdraw Your Investment Amount </h4>
        <h4 class="modal-sub-title">From Investment available to withdraw post completion of Minimum Holding Period,
            Choose the amount you wish to redeem to your bank account.</h4>
    </div>

    <div class="modal-body1">
        <table class="table" style="text-align: center;">
            <tbody>
                <tr>
                    <th class="tableHeader">Product Name</th>
                    <th class="tableHeader">Interest</th>
                    <th class="tableHeader">Withdrawable Amount</th>
                    <th class="tableHeader">Enter Amount to Withdraw</th>
                </tr>
                <ng-container *ngFor="let product of lenderAccountInfo?.products; let i=index">
                    <tr style="background-color: #f9f9f9;"
                        *ngIf="withdrawalRequestForm.get('withdrawalRequests.' + i)">
                        <td class="tableData">
                            <div>{{product.productCode}}</div>
                        </td>
                        <td class="tableData">
                            <div>{{product.roi | number: '1.0-0'}}% p.a.</div>
                        </td>
                        <td class="tableData">
                            <div [ngStyle]="getAmountStylings(product.withdrawBackMoney)">₹ {{priciseNumber(product.withdrawBackMoney) | number : "1.0-2"}}</div>
                        </td>
                        <td class="tableData">
                            <ng-container formArrayName="withdrawalRequests">
                                <div class="flex-box" [formGroupName]="i">
                                    <input class="input-field" type="number" formControlName="withdrawalAmount"
                                        [ngClass]="{'invalid': withdrawalRequestForm.get('withdrawalRequests.' + i + '.withdrawalAmount')?.invalid}"
                                        [placeholder]="'Enter '+ product.productCode +'- Amount'" min="1"
                                        onkeypress="if((this.value.includes('.') && this.value.split('.')[1].length >= 2)) return false"
                                        [max]="priciseNumber(product.withdrawBackMoney)"/>
                                </div>
                            </ng-container>
                        </td>
                    </tr>
                    <tr *ngIf="withdrawalRequestForm.get('withdrawalRequests.' + i + '.withdrawalAmount')?.invalid" >
                        <td colspan="4" class="errorMessage" style="text-align: right; color: red;">
                            <span>{{getErrorMessage(withdrawalRequestForm.get('withdrawalRequests.' + i + '.withdrawalAmount'))}}</span>
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </div>

    <div class="modal-footer box-shadow">
        <button type="button" mat-stroked-button class="primary no-text-transform mr-3" (click)="onMayBeLater()"
            style="font-weight: bold;">
            MAY BE LATER
        </button>

        <button 
            type="button" 
            mat-flat-button class="primary no-text-transform continue-button"
            [disabled]="withdrawalRequestForm?.invalid || getTotalWithdrawalAmount() < 1 || withdrawalRequestInProgress"
            cdkFocusInitial (click)="onWithdrawMoney()">
            WITHDRAW INVESTMENT {{getTotalWithdrawalAmount() <= 0 ? '' : '(₹ ' + (getTotalWithdrawalAmount() | number : "1.0-2").toString() + ') '}}
        </button>
    </div>
</div>